/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import React from 'react';
import { cssMap, jsx } from '@compiled/react';

import { token } from '@atlaskit/tokens';

// The stack scales to the width of its clipping window; the viewBox keeps the ratio.
const styles = cssMap({
	root: {
		display: 'block',
		width: '100%',
		height: 'auto',
	},
	mask: {
		maskType: 'alpha',
	},
});

export const GoogleDriveCardStack = ({ testId }: { testId?: string }): React.JSX.Element => (
	<svg
		css={styles.root}
		width="333"
		height="135"
		viewBox="0 0 333 135"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		role="presentation"
		data-testid={testId}
	>
		<g filter="url(#filter0_dd_70_9512)">
			<g clipPath="url(#clip0_70_9512)">
				<rect
					x="6.87573"
					y="23.4559"
					width="160"
					height="104"
					rx="12"
					transform="rotate(-4 6.87573 23.4559)"
					fill={token('elevation.surface.raised')}
				/>
				<rect
					x="15.4143"
					y="30.8784"
					width="144"
					height="88"
					rx="12"
					transform="rotate(-4 15.4143 30.8784)"
					fill={token('elevation.surface.sunken')}
				/>
				<g opacity="0.05">
					<path
						d="M38.8956 102.68C36.1437 102.975 36.1392 105.108 38.9545 105.263C42.9394 105.477 47.087 105.456 52.4182 105.237C58.4486 104.854 59.9302 104.34 64.0239 104.189C70.9348 103.853 82.6141 103.855 85.4256 103.864C85.842 103.867 86.257 103.85 86.6708 103.815C89.6387 103.588 102.67 102.594 113.906 102.212C121.832 101.843 126.741 101.621 129.306 101.5C135.346 101.244 139.883 100.837 144.245 100.404C146.456 100.249 146.897 98.4063 144.269 98.097C139.76 97.7144 135.225 97.6922 129.152 97.912C126.796 98.0127 121.864 97.7109 114.933 97.9522C113.803 97.9928 112.675 98.078 111.564 98.2134C101.939 99.3731 89.4004 99.8144 89.4004 99.8144C89.4004 99.8144 70.7047 100.744 62.8116 101.136C56.8705 101.423 54.0119 101.566 52.257 101.65C46.9408 101.9 42.8099 102.253 38.8951 102.674L38.8956 102.68Z"
						fill={token('color.text')}
					/>
					<path
						d="M36.846 73.3697C34.0942 73.6646 34.0896 75.7971 36.905 75.9524C40.8898 76.1668 45.0375 76.1457 50.3686 75.9266C56.399 75.5433 57.8807 75.0299 61.9744 74.8781C68.8853 74.5421 80.5645 74.545 83.376 74.5533C83.7924 74.5562 84.2075 74.54 84.6212 74.5047C87.5891 74.2779 100.62 73.2835 111.856 72.9011C119.783 72.5325 124.691 72.311 127.257 72.1892C133.296 71.9334 137.833 71.5265 142.195 71.0934C144.406 70.9388 144.847 69.0959 142.22 68.7866C137.711 68.404 133.176 68.3817 127.102 68.6016C124.746 68.7023 119.814 68.4004 112.884 68.6417C111.753 68.6824 110.626 68.7676 109.515 68.9029C99.889 70.0627 87.3508 70.504 87.3508 70.504C87.3508 70.504 68.6551 71.4336 60.762 71.8254C54.8209 72.1128 51.9624 72.2551 50.2074 72.3394C44.8912 72.5895 40.7604 72.9424 36.8456 73.3634L36.846 73.3697Z"
						fill={token('color.text')}
					/>
				</g>
				<path
					d="M30.8806 51.3574C30.8097 50.3436 30.7743 49.8367 30.9053 49.4235C30.9992 49.1275 31.1528 48.8539 31.3565 48.6196C31.5602 48.3853 31.8098 48.1952 32.0898 48.061C32.4807 47.8737 32.9876 47.8382 34.0014 47.7673L40.8937 47.2854C41.9075 47.2145 42.4144 47.179 42.8276 47.3101C43.1236 47.4039 43.3972 47.5575 43.6316 47.7612C43.8659 47.9649 44.056 48.2145 44.1902 48.4945C44.3774 48.8855 44.4129 49.3923 44.4838 50.4062L44.8231 55.258C44.8939 56.2717 44.9294 56.7787 44.7983 57.1919C44.7045 57.4879 44.5509 57.7615 44.3472 57.9958C44.1435 58.2302 43.8939 58.4203 43.6139 58.5544C43.223 58.7417 42.716 58.7772 41.7022 58.848L34.81 59.33C33.7962 59.4009 33.2893 59.4363 32.8759 59.3053C32.58 59.2114 32.3064 59.0579 32.0721 58.8542C31.8378 58.6504 31.6477 58.4009 31.5135 58.1209C31.3262 57.7299 31.2908 57.223 31.2199 56.2092L30.8806 51.3574Z"
					fill="#009954"
				/>
				<mask
					id="mask0_70_9512"
					css={styles.mask}
					maskUnits="userSpaceOnUse"
					x="32"
					y="45"
					width="20"
					height="16"
				>
					<path
						d="M48.227 45.2925L34.6239 46.2437C33.3717 46.3312 32.4277 47.4173 32.5152 48.6694L33.2128 58.6451C33.3003 59.8972 34.3864 60.8413 35.6385 60.7537L49.2417 59.8025C50.4938 59.7149 51.4379 58.6289 51.3503 57.3768L50.6528 47.4011C50.5652 46.149 49.4792 45.2049 48.227 45.2925Z"
						fill="#0EBC5F"
					/>
				</mask>
				<g mask="url(#mask0_70_9512)">
					<path
						d="M32.3567 46.4022L50.4942 45.1339L51.5089 59.6439L33.3713 60.9122L32.3567 46.4022Z"
						fill="#0EBC5F"
					/>
					<g filter="url(#filter1_f_70_9512)">
						<path
							d="M44.8764 58.6265L34.3566 59.3621C32.7539 59.4742 31.3637 58.2658 31.2517 56.6631L30.849 50.9044C30.7369 49.3017 31.9453 47.9115 33.5481 47.7995L44.0678 47.0638C45.6706 46.9518 47.0607 48.1602 47.1728 49.7629L47.5754 55.5216C47.6875 57.1243 46.4791 58.5144 44.8764 58.6265Z"
							fill="url(#paint0_linear_70_9512)"
						/>
					</g>
				</g>
				<path
					d="M39.4104 56.0466L48.9326 55.3808M46.816 57.6931L46.3087 50.4381"
					stroke="white"
					strokeWidth="3.27273"
					strokeLinecap="round"
				/>
			</g>
		</g>
		<g filter="url(#filter2_dd_70_9512)">
			<g clipPath="url(#clip1_70_9512)">
				<rect
					x="166.388"
					y="13.1191"
					width="160"
					height="104"
					rx="12"
					transform="rotate(4 166.388 13.1191)"
					fill={token('elevation.surface.raised')}
				/>
				<rect
					x="173.81"
					y="21.6577"
					width="144"
					height="88"
					rx="12"
					transform="rotate(4 173.81 21.6577)"
					fill={token('elevation.surface.sunken')}
				/>
				<g opacity="0.05">
					<path
						d="M190.873 98.1791C188.107 98.0881 187.806 100.199 190.572 100.745C194.488 101.512 198.598 102.068 203.908 102.593C209.933 103.053 211.472 102.751 215.547 103.17C222.437 103.799 234.003 105.427 236.786 105.827C237.197 105.888 237.611 105.929 238.025 105.952C240.996 106.141 254.038 106.969 265.218 108.154C273.119 108.893 278.011 109.356 280.568 109.593C286.584 110.18 291.134 110.408 295.514 110.587C297.725 110.741 298.418 108.978 295.859 108.306C291.447 107.299 286.96 106.646 280.914 106.019C278.568 105.79 273.725 104.805 266.829 104.08C265.704 103.962 264.575 103.89 263.456 103.869C253.763 103.678 241.285 102.37 241.285 102.37C241.285 102.37 222.642 100.689 214.771 99.9783C208.848 99.436 205.997 99.1791 204.248 99.0183C198.949 98.5261 194.809 98.3006 190.874 98.1727L190.873 98.1791Z"
						fill={token('color.text')}
					/>
					<path
						d="M192.923 68.8687C190.157 68.7777 189.855 70.8888 192.622 71.4344C196.538 72.2013 200.648 72.7576 205.958 73.2826C211.983 73.7423 213.522 73.4401 217.596 73.8596C224.487 74.4887 236.052 76.1169 238.835 76.5164C239.247 76.5773 239.66 76.619 240.075 76.6416C243.046 76.8301 256.088 77.6589 267.268 78.844C275.169 79.5822 280.06 80.0459 282.618 80.2824C288.634 80.8695 293.183 81.098 297.563 81.2762C299.774 81.4308 300.468 79.6673 297.909 78.9953C293.497 77.9889 289.009 77.3357 282.964 76.7081C280.617 76.48 275.775 75.4947 268.878 74.7691C267.753 74.652 266.625 74.5795 265.506 74.5589C255.812 74.3677 243.335 73.0597 243.335 73.0597C243.335 73.0597 224.692 71.3783 216.821 70.6679C210.898 70.1256 208.047 69.8686 206.297 69.7079C200.998 69.2157 196.858 68.9902 192.923 68.8623L192.923 68.8687Z"
						fill={token('color.text')}
					/>
				</g>
				<path
					d="M282.222 49.4012C282.052 47.568 283.401 45.9446 285.234 45.7753L296.852 44.7022C298.685 44.533 300.309 45.8818 300.478 47.7148L301.479 58.5478C301.648 60.381 300.299 62.0043 298.466 62.1736L286.848 63.2468C285.015 63.4161 283.392 62.0673 283.222 60.2341L282.222 49.4012Z"
					fill="url(#paint1_linear_70_9512)"
				/>
				<path
					d="M282.166 49.1913C282.24 48.1292 282.277 47.5981 282.474 47.1886C282.614 46.8952 282.813 46.6338 283.059 46.4204C283.304 46.207 283.591 46.0462 283.901 45.9478C284.334 45.8104 284.865 45.8476 285.927 45.9218L298.848 46.8253C299.91 46.8996 300.441 46.9367 300.85 47.1329C301.144 47.2735 301.405 47.4727 301.619 47.7182C301.832 47.9637 301.993 48.2503 302.091 48.5604C302.228 48.9932 302.191 49.5243 302.117 50.5864L301.546 58.7569C301.471 59.819 301.434 60.35 301.238 60.7596C301.098 61.053 300.898 61.3144 300.653 61.5278C300.407 61.7413 300.121 61.9021 299.811 62.0004C299.378 62.1377 298.847 62.1006 297.785 62.0263L284.864 61.1228C283.802 61.0485 283.271 61.0114 282.861 60.8152C282.568 60.6746 282.306 60.4755 282.093 60.23C281.88 59.9845 281.719 59.6979 281.62 59.3878C281.483 58.9549 281.52 58.4238 281.594 57.3618L282.166 49.1913Z"
					fill="url(#paint2_linear_70_9512)"
				/>
				<mask
					id="mask1_70_9512"
					css={styles.mask}
					maskUnits="userSpaceOnUse"
					x="281"
					y="45"
					width="22"
					height="18"
				>
					<path
						d="M282.166 49.1913C282.24 48.1292 282.277 47.5981 282.474 47.1886C282.614 46.8952 282.813 46.6338 283.059 46.4204C283.304 46.207 283.591 46.0462 283.901 45.9478C284.334 45.8104 284.865 45.8476 285.927 45.9218L298.848 46.8253C299.91 46.8996 300.441 46.9367 300.85 47.1329C301.144 47.2735 301.405 47.4727 301.619 47.7182C301.832 47.9637 301.993 48.2503 302.091 48.5604C302.228 48.9932 302.191 49.5243 302.117 50.5864L301.546 58.7569C301.471 59.819 301.434 60.35 301.238 60.7596C301.098 61.053 300.898 61.3144 300.653 61.5278C300.407 61.7413 300.121 61.9021 299.811 62.0004C299.378 62.1377 298.847 62.1006 297.785 62.0263L284.864 61.1228C283.802 61.0485 283.271 61.0114 282.861 60.8152C282.568 60.6746 282.306 60.4755 282.093 60.23C281.88 59.9845 281.719 59.6979 281.62 59.3878C281.483 58.9549 281.52 58.4238 281.594 57.3618L282.166 49.1913Z"
						fill="#FEC700"
					/>
				</mask>
				<g mask="url(#mask1_70_9512)">
					<g filter="url(#filter3_f_70_9512)">
						<path
							d="M283.669 64.801L300.996 63.4373L299.427 43.4989L282.099 44.8626L283.669 64.801Z"
							fill="#FFBE00"
						/>
						<path
							d="M283.669 64.801L300.996 63.4373L299.427 43.4989L282.099 44.8626L283.669 64.801Z"
							fill="url(#paint3_linear_70_9512)"
						/>
					</g>
				</g>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M298.347 49.8931C298.536 49.9063 298.712 49.9941 298.836 50.137C298.96 50.28 299.022 50.4665 299.009 50.6555L298.478 58.256C298.465 58.4449 298.377 58.6209 298.234 58.7452C298.091 58.8695 297.904 58.9319 297.715 58.9187L285.365 58.055L285.328 58.0515C285.146 58.0293 284.98 57.9383 284.863 57.797C284.747 57.6558 284.689 57.4753 284.702 57.2926L285.233 49.6922C285.246 49.5095 285.329 49.3388 285.464 49.2152C285.599 49.0915 285.776 49.0245 285.959 49.0278L285.996 49.0294L298.347 49.8931ZM286.177 56.6798L297.103 57.4438L297.534 51.2684L286.609 50.5044L286.177 56.6798Z"
					fill="white"
				/>
			</g>
		</g>
		<g filter="url(#filter4_dd_70_9512)">
			<rect
				x="81.5081"
				y="8"
				width="160"
				height="104"
				rx="12"
				fill={token('elevation.surface.raised')}
			/>
			<g clipPath="url(#clip2_70_9512)">
				<rect
					x="89.5081"
					y="16"
					width="144"
					height="88"
					rx="12"
					fill={token('elevation.surface.sunken')}
				/>
				<g opacity="0.05">
					<g clipPath="url(#clip3_70_9512)">
						<path
							d="M204.759 40.2357C204 39.0511 203.37 37.9907 202.816 37.0856C202.261 36.1849 201.817 35.4173 201.485 34.7917C200.815 33.5361 200.584 32.8395 200.748 32.7197C200.917 32.5999 201.485 33.0658 202.425 34.1395C202.896 34.6763 203.459 35.3641 204.111 36.2115C204.759 37.0589 205.464 38.0838 206.263 39.2596C207.412 40.9145 208.468 42.6494 209.577 44.3753C210.119 45.2449 210.638 46.1367 211.175 47.0285C211.441 47.4722 211.707 47.9203 211.973 48.3684C212.226 48.8254 212.484 49.2824 212.741 49.7439C214.817 53.4043 216.761 57.2865 218.456 61.4926C220.133 65.6943 221.619 70.2376 222.187 75.2779C222.458 77.7891 222.515 80.4335 222.036 83.1311C221.566 85.8198 220.488 88.5706 218.642 90.9C218.154 91.5877 217.537 92.1334 216.978 92.7102C216.69 92.9853 216.366 93.216 216.069 93.4645C215.762 93.7041 215.474 93.9614 215.146 94.1522C214.507 94.5604 213.894 94.9819 213.242 95.2792C212.923 95.4389 212.603 95.5986 212.293 95.7583C211.969 95.887 211.649 96.0112 211.334 96.1399C208.797 97.1204 206.374 97.5286 204.16 97.7283C199.71 98.0877 196.032 97.6174 192.686 97.014C189.341 96.3839 186.306 95.5454 183.143 94.4761C179.979 93.3979 176.683 92.0846 172.894 90.2655C166.496 87.1908 159.357 82.8205 152.653 77.3233C145.935 71.8482 139.679 65.2373 134.799 58.2448C132.354 54.7575 130.247 51.1903 128.507 47.7029C128.09 46.8244 127.664 45.9637 127.27 45.1074C126.897 44.2422 126.533 43.3903 126.178 42.5562L126.045 42.2412L125.912 41.8862C125.819 41.6511 125.752 41.4115 125.681 41.1719C125.544 40.6927 125.442 40.2091 125.371 39.7255C125.233 38.7582 125.229 37.791 125.34 36.8637C125.57 35.0002 126.285 33.3054 127.341 31.9566L127.531 31.6992L127.758 31.4552C127.913 31.2955 128.064 31.1402 128.219 30.9849C128.383 30.8385 128.574 30.7054 128.752 30.5678C128.929 30.4303 129.111 30.3016 129.324 30.204C129.528 30.0975 129.732 29.9955 129.936 29.9023C130.154 29.8313 130.375 29.7692 130.593 29.7115C130.81 29.6405 131.028 29.6139 131.245 29.6006C131.462 29.5829 131.68 29.5562 131.888 29.5607C132.718 29.6006 133.477 29.7692 134.098 30.0265C134.413 30.1508 134.724 30.275 134.981 30.4303C135.247 30.5767 135.527 30.7098 135.748 30.8695C135.979 31.0248 136.205 31.1757 136.423 31.3177C136.622 31.473 136.818 31.6238 137.004 31.7702C137.386 32.0542 137.683 32.347 137.976 32.6043C139.32 33.8378 140.46 35.1999 141.507 36.6064C142.444 37.862 143.695 39.6944 145.088 42.0681C146.477 44.4418 148.021 47.3568 149.591 50.751C151.162 54.1452 152.781 58.0141 154.321 62.2912C155.865 66.5684 157.351 71.2492 158.616 76.2717C159.872 81.2942 160.954 86.6539 161.433 92.302C161.54 93.7174 161.633 95.1416 161.633 96.5925C161.655 97.3157 161.62 98.0433 161.611 98.7754C161.562 99.5075 161.544 100.24 161.46 100.98C161.327 102.458 161.092 103.949 160.688 105.431C160.284 106.913 159.725 108.399 158.855 109.779C158.629 110.12 158.421 110.471 158.141 110.781C157.879 111.105 157.618 111.429 157.303 111.713L156.846 112.152C156.681 112.286 156.508 112.41 156.335 112.538C156.167 112.663 155.985 112.8 155.83 112.907L155.395 113.195C154.818 113.586 154.259 113.998 153.718 114.429L153.314 114.757L152.844 115.121L152.364 115.489C152.2 115.604 152.027 115.711 151.859 115.822C150.505 116.7 149.006 117.339 147.466 117.738C145.927 118.142 144.347 118.315 142.794 118.324C139.679 118.337 136.654 117.747 133.787 116.86C130.917 115.981 128.188 114.801 125.584 113.479C121.914 111.589 118.622 109.446 115.641 107.214C112.664 104.974 109.997 102.635 107.65 100.222C105.312 97.7993 103.266 95.3147 101.713 92.6171C100.955 91.2549 100.307 89.844 99.9786 88.2689C99.8189 87.4836 99.7612 86.6406 99.881 85.7799C99.9875 84.9236 100.347 84.0318 100.906 83.3396C101.461 82.6519 102.153 82.1106 102.849 81.7912C103.022 81.6936 103.195 81.6181 103.368 81.556C103.541 81.4895 103.714 81.4229 103.887 81.3563C104.229 81.2543 104.571 81.1611 104.908 81.0813C106.261 80.7973 107.623 80.7663 108.888 80.9792C111.435 81.383 113.569 82.6386 115.108 84.1604C115.303 84.3468 115.481 84.5553 115.663 84.7461C115.836 84.9369 115.978 85.1188 116.133 85.3007C116.444 85.6601 116.728 86.0283 117.012 86.3833C117.575 87.0932 118.09 87.7898 118.569 88.4597C119.523 89.7997 120.326 91.0508 121.023 92.1822C124.292 97.5464 126.684 102.933 128.49 108.195C130.273 113.466 131.462 118.648 131.822 123.755C131.986 126.306 131.955 128.839 131.56 131.32C131.183 133.791 130.429 136.227 129.138 138.383C127.86 140.539 125.983 142.358 123.782 143.477C122.691 144.04 121.542 144.466 120.375 144.754C119.208 145.025 118.028 145.207 116.852 145.273C115.561 145.344 114.434 145.296 113.484 145.194C113.01 145.132 112.575 145.087 112.18 145.016C111.789 144.941 111.439 144.87 111.128 144.799C109.895 144.484 109.314 144.195 109.345 144.022C109.376 143.84 110.019 143.774 111.257 143.792C111.869 143.796 112.637 143.805 113.555 143.809C114.469 143.809 115.53 143.783 116.728 143.676C117.819 143.583 118.893 143.379 119.94 143.108C120.983 142.815 121.985 142.412 122.926 141.893C124.812 140.868 126.36 139.288 127.434 137.389C128.516 135.49 129.155 133.298 129.457 131.013C129.776 128.728 129.772 126.346 129.577 123.928C129.164 119.083 127.966 114.087 126.2 108.989C124.412 103.9 122.061 98.6645 118.897 93.4911C118.281 92.4884 117.557 91.3614 116.692 90.1546C115.831 88.9567 114.82 87.6256 113.657 86.3389C112.566 85.1587 111.04 84.1471 109.225 83.7167C108.32 83.5038 107.353 83.4106 106.377 83.5348C105.888 83.5792 105.396 83.699 104.921 83.841C104.673 83.8987 104.473 84.014 104.242 84.0939C104.131 84.1382 104.043 84.2048 103.941 84.2536C103.843 84.3068 103.732 84.3557 103.657 84.4266C103.28 84.6618 103.036 84.9724 102.84 85.3096C102.805 85.4027 102.738 85.4782 102.716 85.5758C102.69 85.6734 102.658 85.771 102.623 85.8686C102.592 86.086 102.539 86.2945 102.548 86.5386C102.521 86.7693 102.57 87.0311 102.583 87.284C102.636 87.5457 102.663 87.8075 102.752 88.0826C102.88 88.6283 103.111 89.1874 103.351 89.7464C104.389 92.0003 106.053 94.2365 107.969 96.3972C109.895 98.5668 112.127 100.665 114.589 102.698C117.052 104.73 119.754 106.677 122.686 108.479C124.594 109.655 126.56 110.737 128.57 111.7C130.575 112.663 132.625 113.515 134.715 114.176C135.837 114.544 136.986 114.846 138.153 115.085C139.32 115.334 140.5 115.493 141.689 115.56C144.059 115.711 146.463 115.436 148.615 114.544C149.689 114.1 150.701 113.506 151.606 112.765C152.129 112.334 152.666 111.922 153.221 111.531C153.496 111.336 153.775 111.145 154.055 110.959L154.481 110.684L154.809 110.44C156.571 109.158 157.684 106.952 158.279 104.619C158.452 104.042 158.549 103.434 158.678 102.84C158.762 102.232 158.878 101.633 158.926 101.016C159.073 99.7959 159.108 98.558 159.135 97.3245C159.157 94.8577 158.975 92.4041 158.7 90.0038C158.132 85.2031 157.174 80.611 156.078 76.3738C153.882 67.895 151.189 60.8093 149.086 55.8978C148.03 53.4397 147.129 51.5142 146.481 50.2097C146.166 49.5531 145.904 49.0562 145.736 48.719C145.563 48.3818 145.474 48.2043 145.474 48.2043C145.474 48.2043 145.336 47.9425 145.079 47.45C144.822 46.9531 144.436 46.2254 143.921 45.3026C142.887 43.4613 141.361 40.7948 139.107 37.8354C137.976 36.3757 136.649 34.8183 135.016 33.5627C134.204 32.9549 133.295 32.4313 132.399 32.245C131.502 32.0764 130.704 32.2849 129.967 32.9327C129.248 33.6026 128.61 34.6098 128.241 35.6835C127.873 36.7661 127.735 37.9596 127.864 39.1531C127.926 39.7477 128.055 40.3466 128.25 40.9279L128.405 41.3627L128.605 41.8374C128.738 42.1524 128.871 42.4719 129.004 42.7913C129.28 43.4258 129.524 44.078 129.83 44.708C130.127 45.3425 130.429 45.9814 130.73 46.6203C131.99 49.1626 133.37 51.7138 134.963 54.1807C135.726 55.4363 136.587 56.6343 137.421 57.8588C137.851 58.4623 138.304 59.0524 138.743 59.6513L139.409 60.5476L140.105 61.4172C143.788 66.0936 147.99 70.3707 152.333 74.1554C161.061 81.698 170.431 87.0444 177.73 90.1014C180.472 91.2816 183.103 92.2089 185.592 92.972C186.834 93.3669 188.054 93.6686 189.23 93.9792C189.82 94.1211 190.401 94.2409 190.974 94.3696C191.546 94.5027 192.11 94.6092 192.664 94.7024C197.101 95.5276 200.979 95.643 204.249 95.3235C207.523 94.9908 210.168 94.1345 212.213 93.0607C214.263 91.9781 215.691 90.656 216.707 89.3693C218.256 87.4126 219.192 85.0833 219.622 82.7052C220.057 80.3181 220.022 77.8956 219.782 75.553C219.285 70.8499 217.914 66.453 216.335 62.3534C214.742 58.2493 212.901 54.407 210.931 50.7643C210.687 50.3073 210.447 49.8503 210.203 49.3978C209.95 48.9497 209.697 48.5015 209.444 48.0579C208.934 47.1705 208.446 46.2787 207.931 45.4046C206.871 43.6743 205.877 41.9306 204.781 40.2623L204.759 40.2357Z"
							fill={token('color.text')}
						/>
					</g>
				</g>
				<mask
					id="mask2_70_9512"
					css={styles.mask}
					maskUnits="userSpaceOnUse"
					x="106"
					y="30"
					width="15"
					height="20"
				>
					<path
						d="M117.348 50H109.538C108.522 50 108.013 50 107.611 49.8409C107.322 49.7266 107.06 49.5543 106.84 49.3346C106.62 49.1149 106.448 48.8525 106.334 48.5636C106.175 48.1602 106.175 47.6523 106.175 46.6364V33.3636C106.175 32.3477 106.175 31.8386 106.334 31.4364C106.448 31.1475 106.62 30.8851 106.84 30.6654C107.06 30.4457 107.322 30.2734 107.611 30.1591C108.013 30 108.522 30 109.538 30H113.902L120.129 36.2273C120.317 36.4148 120.411 36.5091 120.484 36.6159C120.589 36.77 120.661 36.9441 120.696 37.1273C120.719 37.2545 120.719 37.3886 120.719 37.6591C120.715 43.2182 120.713 43.2727 120.713 46.633C120.713 47.6511 120.713 48.1614 120.554 48.5648C120.44 48.8535 120.267 49.1156 120.048 49.3351C119.828 49.5546 119.566 49.7267 119.277 49.8409C118.873 50 118.365 50 117.348 50Z"
						fill="#3186FF"
					/>
				</mask>
				<g mask="url(#mask2_70_9512)">
					<path d="M120.713 50H106.175V30H113.902L120.72 36.8182L120.713 50Z" fill="#3186FF" />
					<g filter="url(#filter5_f_70_9512)">
						<path
							d="M107.425 50.9095H119.47V31.364H107.425V50.9095Z"
							fill="url(#paint4_linear_70_9512)"
						/>
					</g>
				</g>
				<path
					d="M120.152 36.25C119.867 36.0352 119.513 35.9091 119.129 35.9091H115.356C114.971 35.9091 114.601 35.7558 114.328 35.4831C114.055 35.2103 113.902 34.8403 113.902 34.4545V30L120.152 36.25Z"
					fill="#76BBFF"
				/>
				<path
					d="M116.402 42.0454H110.493C110.116 42.0454 109.811 42.3507 109.811 42.7272C109.811 43.1038 110.116 43.409 110.493 43.409H116.402C116.779 43.409 117.084 43.1038 117.084 42.7272C117.084 42.3507 116.779 42.0454 116.402 42.0454Z"
					fill="white"
				/>
				<path
					d="M114.584 45.3409H110.493C110.116 45.3409 109.811 45.6462 109.811 46.0228C109.811 46.3993 110.116 46.7046 110.493 46.7046H114.584C114.96 46.7046 115.266 46.3993 115.266 46.0228C115.266 45.6462 114.96 45.3409 114.584 45.3409Z"
					fill="white"
				/>
			</g>
		</g>
		<defs>
			<filter
				id="filter0_dd_70_9512"
				x="-1.12427"
				y="4.29492"
				width="182.865"
				height="130.908"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_70_9512" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_70_9512"
					result="effect2_dropShadow_70_9512"
				/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_70_9512" result="shape" />
			</filter>
			<filter
				id="filter1_f_70_9512"
				x="27.5691"
				y="43.7839"
				width="23.2864"
				height="18.8582"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.63636" result="effect1_foregroundBlur_70_9512" />
			</filter>
			<filter
				id="filter2_dd_70_9512"
				x="151.133"
				y="5.11914"
				width="182.865"
				height="130.908"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_70_9512" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_70_9512"
					result="effect2_dropShadow_70_9512"
				/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_70_9512" result="shape" />
			</filter>
			<filter
				id="filter3_f_70_9512"
				x="278.671"
				y="40.0703"
				width="25.7539"
				height="28.1593"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.71429" result="effect1_foregroundBlur_70_9512" />
			</filter>
			<filter
				id="filter4_dd_70_9512"
				x="73.5081"
				y="0"
				width="176"
				height="120"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="4" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.16 0"
				/>
				<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_70_9512" />
				<feColorMatrix
					in="SourceAlpha"
					type="matrix"
					values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
					result="hardAlpha"
				/>
				<feOffset />
				<feGaussianBlur stdDeviation="0.5" />
				<feColorMatrix
					type="matrix"
					values="0 0 0 0 0.117647 0 0 0 0 0.121569 0 0 0 0 0.129412 0 0 0 0.12 0"
				/>
				<feBlend
					mode="normal"
					in2="effect1_dropShadow_70_9512"
					result="effect2_dropShadow_70_9512"
				/>
				<feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_70_9512" result="shape" />
			</filter>
			<filter
				id="filter5_f_70_9512"
				x="104.152"
				y="28.0913"
				width="18.5909"
				height="26.0909"
				filterUnits="userSpaceOnUse"
				colorInterpolationFilters="sRGB"
			>
				<feFlood floodOpacity="0" result="BackgroundImageFix" />
				<feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape" />
				<feGaussianBlur stdDeviation="1.63636" result="effect1_foregroundBlur_70_9512" />
			</filter>
			<linearGradient
				id="paint0_linear_70_9512"
				x1="44.9683"
				y1="53.6865"
				x2="33.4646"
				y2="54.4909"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#0EBC5F" />
				<stop offset="0.95" stopColor="#78C9FF" />
			</linearGradient>
			<linearGradient
				id="paint1_linear_70_9512"
				x1="291.043"
				y1="45.2387"
				x2="298.585"
				y2="62.1811"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.2" stopColor="#FFDB0F" />
				<stop offset="0.67" stopColor="#FFBE00" />
				<stop offset="0.91" stopColor="#FFA8E3" />
			</linearGradient>
			<linearGradient
				id="paint2_linear_70_9512"
				x1="292.387"
				y1="46.3736"
				x2="291.324"
				y2="61.5746"
				gradientUnits="userSpaceOnUse"
			>
				<stop stopColor="#FFBE00" />
				<stop offset="1" stopColor="#FEC700" />
			</linearGradient>
			<linearGradient
				id="paint3_linear_70_9512"
				x1="292.743"
				y1="62.6483"
				x2="291.013"
				y2="45.4751"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.07" stopColor="#FFF549" />
				<stop offset="0.78" stopColor="#FFBE00" stopOpacity="0" />
			</linearGradient>
			<linearGradient
				id="paint4_linear_70_9512"
				x1="113.447"
				y1="35.8277"
				x2="108.744"
				y2="48.5617"
				gradientUnits="userSpaceOnUse"
			>
				<stop offset="0.33" stopColor="#3186FF" />
				<stop offset="1" stopColor="#A9A8FF" />
			</linearGradient>
			<clipPath id="clip0_70_9512">
				<rect
					x="6.87573"
					y="23.4559"
					width="160"
					height="104"
					rx="12"
					transform="rotate(-4 6.87573 23.4559)"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip1_70_9512">
				<rect
					x="166.388"
					y="13.1191"
					width="160"
					height="104"
					rx="12"
					transform="rotate(4 166.388 13.1191)"
					fill="white"
				/>
			</clipPath>
			<clipPath id="clip2_70_9512">
				<rect x="89.5081" y="16" width="144" height="88" rx="12" fill="white" />
			</clipPath>
			<clipPath id="clip3_70_9512">
				<rect
					width="122.577"
					height="115.757"
					fill="white"
					transform="matrix(-1 0 0 1 222.396 29.5563)"
				/>
			</clipPath>
		</defs>
	</svg>
);
